<template>
  <div class="FileIcon">
    <aw-icon
      icon="document"
      class="text-gray-400  flex-grow"
      :class="computedSize"
    />
    <div class="text-xs flex-grow text-center max-w-full truncate">
      {{ ext }}
    </div>
  </div>
</template>

<script>
const defaultSize = 'small'
const sizeMap = {
  small: 'w-8 h-8',
  medium: 'w-16 h-16',
  large: 'w-24 h-24'
}

export default {
  props: {
    ext: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      validator: (size) => {
        return Object.keys(sizeMap).includes(size)
      }
    }
  },
  computed: {
    computedSize() {
      if (!this.size) {
        return sizeMap[defaultSize]
      }
      return sizeMap[this.size]
    }
  }
}
</script>

<style lang="scss" scoped></style>
